import { Box, SxProps, Typography, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

export interface IFeatureLabelProps {
  label: string
  value: string
  multiLine?: boolean
  sx?: SxProps
}

export const FeatureLabel: React.FC<IFeatureLabelProps> = ({
  label,
  value,
  multiLine = false,
  sx = {},
}) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`VuiDescriptionList`]?.styleOverrides || {}
  const { root, labelText, contentText } = styleOverrides

  const hasSeparator = value && /[,;]/.test(value)

  const splitValues = hasSeparator
    ? value
        .split(/[,;]/)
        .map((line) => line.trim())
        .filter(Boolean)
    : [value]

  return (
    <Box sx={deepmerge(root, sx)} className="VuiDescriptionList-root">
      <Typography
        variant="h6"
        className="VuiDescriptionList-labelText"
        sx={labelText}
      >
        {label}
      </Typography>
      {multiLine && splitValues.length > 1 ? (
        <>
          {splitValues.map((line, idx) => (
            <Typography
              key={idx}
              variant="subtitle2"
              className="VuiDescriptionList-contentText"
              sx={contentText}
            >
              {line}
            </Typography>
          ))}
        </>
      ) : (
        <Typography
          variant="subtitle2"
          className="VuiDescriptionList-contentText"
          sx={contentText}
        >
          {value}
        </Typography>
      )}
    </Box>
  )
}
